import { Formik } from "formik";
import React, { useState } from "react";
import { API, fileUpload, riskProfile } from "../../../config";
import Spin from "../../../components/Spin";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
// import { useOrganization } from "../../../lib/context/OrganisationContext";
// import { formatSubcontractorName } from "../../../lib/Misc";
// import UserSelect from "../../../components/UserSelect";
// import { Loader2 } from "lucide-react";
import { Button } from "../../../components/ui/button";
import SearchSelect from "../../../components/SearchSelect";
import { Textarea } from "../../../components/ui/textarea";
import { useUser } from "../../../lib/context/UserContext";
import { RiskChangeSchema } from "../../../lib/Validation";

const RiskChange = ({ data, toggleRisk, fetchData }) => {
  // const { organizationData } = useOrganization();
  const { userData } = useUser();
  const [loading, setLoading] = useState(false);

  // const [userLoading, setUserLoading] = useState(false);
  // const [userListing, setUserListing] = useState([]);
  // const [userList, setUserList] = useState([]);

  // useEffect(() => {
  //   if (userList) {
  //     let userTempListing = userList?.map((item) => ({
  //       ...item,
  //       value: item?.id,
  //       label: formatSubcontractorName(item),
  //     }));
  //     setUserListing(userTempListing || []);
  //   } else {
  //     setUserListing([]);
  //   }
  // }, [userList]);

  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    // formData.append(`user_id`, value.user_id ?? "");
    formData.append(`risk`, value.risk ?? "");
    formData.append(`reason`, value.reason ?? "");

    formData.append("_method", "put");
    try {
      setLoading(true);
      const response = await fileUpload(
        `${API.GET_CDD_RISK}${data?.id ? `/${data?.id}` : ""}`,
        formData,
      );
      setLoading(false);
      if (response?.data) {
        toggleRisk();
        fetchData && fetchData();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <Formik
      initialValues={{
        id: data?.id ? data?.id : "",
        user_id: data?.risk_profile_changes?.user_id ? data?.risk_profile_changes?.user_id : userData?.id,
        risk: data?.risk_profile_changes?.risk ? data?.risk_profile_changes?.risk : data?.risk,
        reason: data?.risk_profile_changes?.reason ? data?.risk_profile_changes?.reason : "",
      }}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={RiskChangeSchema}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-hidden overflow-y-auto max-h-[80vh] p-4 border rounded-lg">
              <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-4">
                {/* User By */}
                {/* <div className="grid gap-2">
                  <div className="min-w-0">
                    <Label htmlFor="user_id">
                      <CustomLabelText
                        labelText="Changed By"
                        errorField={errors?.user_id}
                        required={true}
                      />
                    </Label>
                    <div className="relative mt-2">
                      <UserSelect
                        orgId={organizationData?.organizationId}
                        frameworkData={userListing} // List of vendors
                        optionType="User"
                        handleSelect={(e) => {
                          setFieldValue(`user_id`, e);
                        }}
                        name="user_id"
                        disabled={values?.verified_using ? true : false}
                        initialValue={values?.user_id ? values?.user_id : ""}
                        authUser={true}
                        setUserList={setUserList}
                        setUserLoading={setUserLoading}
                        onClear={() => {
                          setFieldValue(`user_id`, "");
                        }}
                        className={
                          errors?.user_id &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        loading={userLoading}
                      />
                      {userLoading && (
                        <span className="absolute top-2 right-2 animate-spin">
                          <Loader2 width={20} height={20} />
                        </span>
                      )}
                    </div>
                  </div>
                </div> */}

                {/* Risk Profile */}
                <div className="grid gap-2">
                  <div className="min-w-0">
                    <Label htmlFor="risk">
                      <CustomLabelText
                        labelText="Risk Profile"
                        errorField={errors?.risk}
                        required={true}
                      />
                    </Label>
                    <div className="relative mt-2">
                      <SearchSelect
                        frameworks={riskProfile}
                        optionType={"Risk Profile"}
                        handleSelect={(e) => {
                          setFieldValue("risk", e);
                        }}
                        handleBlur={handleBlur}
                        className={
                          errors?.risk &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        disabled={data?.status ? true : false}
                        initialValue={values?.risk}
                      />
                    </div>
                  </div>
                </div>

                {/* Reason */}
                <div className="grid gap-2 col-span-2">
                  <Label htmlFor="reason">
                    <CustomLabelText
                      labelText="Reason"
                      required={true}
                      errorField={errors?.reason}
                    />
                  </Label>
                  <Textarea
                    name="reason"
                    rows={4}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.reason}
                    disabled={data?.status ? true : false}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleRisk();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default RiskChange;
